import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.9 14.75A6.75 6.75 0 1 1 14.65 8a6.75 6.75 0 0 1-6.75 6.75Zm0-12A5.25 5.25 0 1 0 13.15 8 5.25 5.25 0 0 0 7.9 2.76Zm0 9.35a.85.85 0 1 0-.84-.84.85.85 0 0 0 .84.85Zm.84-3.18c0-.15.3-.46.47-.65v-.05a2.67 2.67 0 0 0 1-2.25A2.2 2.2 0 0 0 8 3.77 2.2 2.2 0 0 0 5.72 6a.75.75 0 0 0 1.5 0A.72.72 0 0 1 8 5.27a.72.72 0 0 1 .78.73c0 .61 0 .66-.58 1.22l-.08.08a2.53 2.53 0 0 0-.88 1.68.75.75 0 0 0 1.5 0Z';
const draw24px =
  'M12,21.75A9.75,9.75,0,1,1,21.75,12,9.77,9.77,0,0,1,12,21.75Zm0-18A8.25,8.25,0,1,0,20.25,12,8.26,8.26,0,0,0,12,3.75Zm0,14a1,1,0,1,0-1-1A1,1,0,0,0,12,17.73Zm.75-4.07a1.48,1.48,0,0,1,.57-1.16l.24-.17c1.14-.85,2-1.46,2-3.41A3.37,3.37,0,0,0,12,5.59,3.36,3.36,0,0,0,8.51,9,.75.75,0,0,0,10,9a1.88,1.88,0,0,1,2-1.93,1.89,1.89,0,0,1,2,1.83c0,1.2-.29,1.41-1.36,2.2l-.25.18a3,3,0,0,0-1.17,2.36.75.75,0,0,0,1.5,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const QuestionCircleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'questionCircle')) as IconWithRender;

QuestionCircleIcon.displayName = 'QuestionCircleIcon';
QuestionCircleIcon.propTypes = Icon.propTypes;
QuestionCircleIcon.renderIcon = (props) => <QuestionCircleIcon {...props} />;
export default QuestionCircleIcon;
